import React from 'react';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/dist/styles.min.css';
const ReactMarkerClusterGroup = (props) => {
    return <MarkerClusterGroup {...props}></MarkerClusterGroup>;
};
export default ReactMarkerClusterGroup;
